import {dateService} from "../datetime/time.js";
import {getCountryInfo} from "../settings/location";


async function getHolidaysPython(countryInfo) {
    const holidays_url = "https://zima-backend.farawaytech.com/v1/holidays/";
    let response = await fetch(holidays_url, {
        headers: {
            'Content-Type': 'application/json'
        },
        method: "POST",
        body: JSON.stringify([{country: countryInfo.countryCode, region: countryInfo.regionCode}]),
        timeout: 3000,
    });
    if (response !== undefined && response.status === 200) {
        let res_json = await response.json();
        return res_json.flatMap(c => c["holidays"]);
    }
    return [];
}

async function getExtraIcon() {
    const icon_url = `https://zima-backend.farawaytech.com/v1/holidays/extra_icon`;
    let response = await fetch(icon_url, {
        headers: {
            'Content-Type': 'application/json'
        },
        method: "GET",
        credentials: 'include',
        timeout: 3000,
    });
    if (response !== undefined && response.status === 200) {
        let res_json = await response.json();
        if (res_json && 'icon' in res_json) {
            return res_json["icon"];
        }
    }
    return null;
}

export async function updateExtraCalIcon() {
    // Remove existing icons
    document.querySelectorAll("#calendar .extra-icon").forEach(e => e.remove());

    let extra_icon = await getExtraIcon();
    if (extra_icon) {
        // Assuming each "cell" div has a specific class (e.g., "calendar-day")
        const calendarCells = document.querySelectorAll('#calendar .calendar-day');
        const lastRowCells = Array.from(calendarCells).slice(-7); // Get the last 7 cells, assuming a 7-column layout
        const firstRowCells = Array.from(calendarCells).slice(0, 7); // Get the first 7 cells

        // Find an empty cell in the last row or default to null
        let emptyCell = lastRowCells.find(cell => !cell.textContent.trim()) || null;
        // Check if all cells in the last row are empty
        let areAllCellsEmpty = lastRowCells.every(cell => !cell.textContent.trim());

        // If no empty cell in the last row or all cells in the last row are empty, look in the first row
        if (!emptyCell || areAllCellsEmpty) {
            emptyCell = firstRowCells.reverse().find(cell => !cell.textContent.trim());
        }

        // If an empty cell is found, append the extra icon
        if (emptyCell) {
            let iconElem = document.createElement("div");
            iconElem.classList.add("extra-icon");
            iconElem.style.backgroundImage = `url('${extra_icon}')`;
            // Reset any text content to ensure the cell is visually empty before adding the icon
            emptyCell.textContent = '';
            emptyCell.appendChild(iconElem);
        }
    }
}


export async function setHolidays() {
    let countryInfo = getCountryInfo();
    console.log(`Fetching holidays for country: ${countryInfo.countryCode}, region: ${countryInfo.regionCode}`);
    let holidays = await getHolidaysPython(countryInfo);

    // update calendar, get only this month holidays
    let month = dateService.getDate().getMonth();
    holidays.forEach(h => {
        let holiday_date = new Date(h["date"] + "T00:00:00");
        if (holiday_date.getMonth() === month) {
            let el = document.querySelector(`#calendar div[data-day="${holiday_date.getDate()}"]`);
            el.classList.add("holiday");
            if (h["custom_class"] != null) {
                let icon_elem = el.getElementsByClassName("custom-icon")[0];
                icon_elem.classList.add(...h["custom_class"].split(" "));
                if (h["custom_class"].startsWith("flag")) {
                    el.classList.add("flag");
                    icon_elem.style["background-image"] = `url('/assets/icons/flags/${countryInfo.countryCode.toLowerCase()}.svg')`
                }
            }
        }
    });
    await updateExtraCalIcon();
}